import {StandardEvents} from '@shopify/events';
let revision=0;
async function refresh(){
 const current=++revision;
 const url=new URL(window.location.href);
 url.searchParams.delete('sections');
 url.searchParams.set('section_id','ags-cart-render');
 const response=await fetch(url,{credentials:'same-origin',cache:'no-store'});
 if(!response.ok)throw new Error('cart');
 const doc=new DOMParser().parseFromString(await response.text(),'text/html');
 const incoming=doc.querySelector('[data-ags-cart]');
 if(!incoming)throw new Error('cart');
 if(current!==revision)return;
 document.querySelectorAll('[data-ags-cart]').forEach(cart=>cart.replaceWith(incoming.cloneNode(true)));
 document.querySelectorAll('.cart-bubble__text-count').forEach(count=>count.textContent=incoming.dataset.count);
}
function error(root,message){root.removeAttribute('aria-busy');const el=root.querySelector('.ags-cart__error');if(el){el.textContent=message||root.dataset.error;el.hidden=false;}}
async function change(control,quantity){
 const root=control.closest('[data-ags-cart]');
 const key=control.closest('[data-key]')?.dataset.key;
 if(!root||!key||!Number.isInteger(quantity)||quantity<0)return;
 root.setAttribute('aria-busy','true');
 try{
  const response=await fetch(root.dataset.cartUrl+'/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},credentials:'same-origin',body:JSON.stringify({id:key,quantity})});
  const result=await response.json();
  if(!response.ok)throw new Error(result.description||root.dataset.error);
  await refresh();
 }catch(e){error(root,e.message);}
}
document.addEventListener('click',event=>{
 const button=event.target.closest('[data-ags-change]');
 if(button){event.preventDefault();change(button,Number(button.dataset.agsChange));}
});
document.addEventListener('change',event=>{
 if(event.target.matches('[data-ags-quantity]'))change(event.target,Number(event.target.value));
});
document.addEventListener(StandardEvents.cartLinesUpdate,async event=>{
 try{const result=await event.promise;if(!result?.detail?.didError)await refresh();}catch(e){document.querySelectorAll('[data-ags-cart]').forEach(root=>error(root));}
});
document.addEventListener('theme-drawer:open',event=>{if(event.target.id==='cart-drawer')refresh().catch(()=>{});});
window.addEventListener('pageshow',event=>{if(event.persisted)refresh().catch(()=>{});});

document.addEventListener('click',event=>{
 const button=event.target.closest('[data-accessory-direction]');
 if(!button)return;
 const list=button.closest('.ags-cart__recommendations').querySelector('.ags-cart__accessory-list');
 list.scrollBy({left:Number(button.dataset.accessoryDirection)*list.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
});
